<style lang="postcss">
	.multi-page-container {
		width: 100%;
	}

	.page-welcome {
		will-change: auto;
	}

	.padding-container {
		padding: 2rem;
	}

	.invisible-container {
		visibility: hidden;
		pointer-events: none;
	}

	.header-text {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		height: 3.5rem;
		width: 100%;
		gap: 1.5rem;
	}

	.form-welcome-button-cover {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-top: 2rem;
		width: 100%;
	}

	.icon-transition {
		margin-left: 0.25rem;
		transition: transform 0.2s;
	}

	.icon-transition:hover {
		transform: translateX(0.125rem);
	}

	.back-button {
		cursor: pointer;
		margin-left: -0.125rem;
		gap: 0.25rem;
		will-change: transform;
	}

	.header-item {
		font-weight: 500;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}

	.page-title {
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-left: auto;
		text-align: right;
		opacity: 0.8;
	}

	.back-button .left-arrow {
		transition: transform 0.15s ease-in-out;
		will-change: transform;
	}

	.back-button:hover .left-arrow {
		transform: translateX(-0.15rem);
	}

	.page-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
	}

	.richtext {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
	}

	.fields-container {
		display: grid;
		grid-template-columns: repeat(20, 1fr);
		column-gap: 5%;
		width: 100%;
	}

	.error-message {
		margin-top: 1rem;
		font-size: 0.85rem;
	}
	.slider-in {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		width: 100%;
		align-items: flex-start;
	}
	.other-pages-cover {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.slider-pages {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		width: 100%;
		align-items: flex-start;
	}

	.form-footer-cover {
		display: flex;
		padding: 0 1.25px 1.25px 1.25px;
		width: 100%;
	}
	.form-footer-cover-inner {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
	}
	@media (max-width: 490px) {
		.form-footer-cover {
			/* padding-bottom: 1rem; */
		}
	}
</style>

<script lang="ts">
	import { getHiddenElementHeight, getHeight } from "./form-functions";
	import DisplayField from "$form/Fields/DisplayField.svelte";
	import { onMount, onDestroy, setContext } from "svelte";
	import Footer from "$form/Footer.svelte";
	import Slider from "$form/Slider.svelte";
	import { BROWSER } from "esm-env";
	import type { Writable } from "svelte/store";
	import { getContext, tick } from "svelte";
	import { pageOut, pageIn, slide, fade, bezier } from "$lib/transitions";
	import { slide as slideOld } from "svelte/transition";
	import { sineIn } from "svelte/easing";
	const test = getContext<boolean>("test");
	import type { t as tBase } from "$lib/helpers/translate";
	import { browser } from "$app/environment";
	const t = getContext<typeof tBase>("t");
	const formMeta = getContext<Writable<FormMeta>>("formMeta");

	let invalid_fields = getContext<Writable<FieldDisplay[]>>("invalid_fields");
	let focusOnErrors = getContext<Function>("focusOnErrors");
	let currentField = getContext<Writable<CurrentField>>("currentField");
	const mounted = getContext<Writable<boolean>>("mounted");
	const lookupLoading = getContext<Writable<string[]>>("lookupLoading");
	let visit = getContext<Writable<Visit>>("visit");
	let visitMeta = getContext<Writable<VisitMeta>>("visitMeta");
	let styling = getContext<Styling>("styling");
	const plan = getContext<PlanShort>("plan");
	const iframe = getContext<boolean>("iframe");
	const formKey = getContext<string>("formKey");
	const remoteValidation =
		getContext<Writable<RemoteValidation[]>>("remoteValidation");

	const timing = getContext<Writable<Timing>>("timing");
	const fireGoogleEvent = getContext<Function>("fireGoogleEvent");
	const powered_by_link =
		import.meta.env.PUBLIC_SITE_URL +
		`?utm_medium=referral&utm_campaign=poweredbylink&utm_content=${formKey}`;

	export let fieldDisplay: FieldDisplay[];
	export let pageDisplay: PageDisplay[];
	export let seamless: boolean;
	export let hidden: boolean = false;
	export let formError: string;
	export let currentPageId: string = "welcome";
	export let formLoading: boolean;

	let pendingEvents: {
		type: string;
		data: any;
	}[] = [];

	let navigating = getContext<Writable<boolean>>("navigating");

	let currentHeight: number = 1;
	let oldHeight: number = 0;
	let pageInDirection = "right";
	let pageOutDirection = "left";
	let lastSlide: boolean = false;
	let eagerTimeout: NodeJS.Timeout | null = null;
	let sliderRef: HTMLDivElement;
	let sliderOuterRef: HTMLDivElement;
	let multiPageRef: HTMLDivElement;
	let mouseEnterDelay: ReturnType<typeof setTimeout>;
	let showBack: boolean = false;
	let stopNavigationTimeout: ReturnType<typeof setTimeout>;
	let tracking: null | {
		page: string;
		time: number;
	} = null;

	$: lastSlide = currentPageId === pageDisplay.slice(-1)[0]?.id;
	$: firstPageId = styling.welcomeEnabled
		? "welcome"
		: pageDisplay.filter((x) => x.visibleComputed)[0]?.id;
	$: showBack = currentPageId !== firstPageId;
	$: currentPageId, slideWasChanged();
	$: currentPageLabel = pageDisplay.find((x) => x.id === currentPageId)?.label;
	$: isLookupLoading = $lookupLoading.filter(Boolean).length > 0;
	$: if ($lookupLoading.length === 0 && BROWSER) {
		setTimeout(() => {
			checkPending();
		}, 600);
		// More than the time between lookups
	}
	$: slideDuration = Math.round(
		(1 - $timing.in - $timing.out) * $timing.duration
	);
	$: enableHeader = getEnableHeader(
		currentPageId,
		firstPageId,
		pageDisplay,
		styling
	);

	function getEnableHeader(
		current: string,
		first: string,
		page: PageDisplay[],
		styling: Styling
	) {
		if (
			styling.welcomeEnabled === false &&
			page.length > 1 &&
			current === first &&
			styling.showPageTitles === false
		) {
			return false;
		}
		if (page.length === 1 && styling.welcomeEnabled === false) {
			return false;
		}
		if (current === first && first === "welcome") {
			return false;
		}
		return true;
	}

	const message = (type: string, content: any) => {
		if (!window || !window.parent) return;
		window.parent.postMessage(
			{
				type,
				content
			},
			"*"
		);
	};

	const checkPending = () => {
		for (const event of pendingEvents) {
			switch (event.type) {
				case "navigate": {
					pendingEvents = pendingEvents.filter((x) => x !== event);
					navigate(event.data);
					break;
				}
			}
		}
	};

	const handleVisibilityChange = () => {
		if (document.visibilityState === "hidden") {
			endTracking();
		} else {
			startTracking();
		}
	};

	const startTracking = () => {
		endTracking();
		tracking = {
			page: currentPageId,
			time: Date.now()
		};
	};

	const endTracking = () => {
		if (tracking) {
			const timeSpent = Date.now() - tracking.time;
			const oldPageId = tracking.page;
			if ($visit.pages[oldPageId]) {
				$visit.pages[oldPageId] += timeSpent;
			} else {
				$visit.pages[oldPageId] = timeSpent;
			}
			tracking = null;
		}
	};

	$: if ($mounted && currentPageId !== "welcome") visitStartForm();

	const slideWasChanged = () => {
		$visit.last_page = currentPageId;
		startTracking();
	};

	export const canWeEager = (fields: FieldDisplay[]) => {
		if (!BROWSER) return;
		let fieldsToCheck: FieldDisplay[] = [];

		fieldsToCheck = fields.filter((x) => x.page === currentPageId);

		const visibleInteractiveFields = fieldsToCheck.filter(
			(x) => x.visibleComputed && x.type !== "Hidden"
		);

		const lastVisibleField =
			visibleInteractiveFields[visibleInteractiveFields.length - 1];

		if (!lastVisibleField) return;
		const activeField = $currentField.tracking ?? null;
		if (!activeField) return;

		// Skip if last field is not the active field
		if (activeField.id !== lastVisibleField.id) {
			return;
		}

		// Don't eager if last field is not selection based
		if (
			lastVisibleField.type !== "Dropdown" &&
			lastVisibleField.type !== "MultipleChoice" &&
			lastVisibleField.type !== "Rating" &&
			lastVisibleField.type !== "NPS"
		) {
			return;
		}
		if (typeof lastVisibleField.settings === "undefined") return;

		// Don't eager if last field is multiple
		if (
			"multiple" in lastVisibleField.settings &&
			lastVisibleField.settings.multiple === true
		) {
			if (
				typeof lastVisibleField.settings.max === "undefined" ||
				lastVisibleField.settings.max === ""
			)
				return;
			if (typeof lastVisibleField.valueComputed === "undefined") return;
			if (
				lastVisibleField.valueComputed?.length <
				parseInt(lastVisibleField.settings.max)
			)
				return;
		} else {
			if (lastVisibleField.valueComputed?.length === 0) return;
		}

		if (!lastSlide) {
			if (eagerTimeout) clearTimeout(eagerTimeout);
			eagerTimeout = setTimeout(async () => {
				navigate(1);
				eagerTimeout = null;
			}, 600);
			// More than the time between lookups
		}
	};

	const navigate = async (direction: number) => {
		if (!browser) return;
		if (isLookupLoading) {
			pendingEvents.push({
				type: "navigate",
				data: direction
			});
			return;
		}
		if (lastSlide && direction > 0) {
			return;
		}
		if ($formMeta.formDisabled) {
			return;
		}
		if (direction > 0 && $invalid_fields.length > 0) {
			focusOnErrors(currentPageId);
			return;
		}
		if (
			direction > 0 &&
			$remoteValidation.filter((x) => x.state === "invalid").length > 0
		) {
			focusOnErrors(currentPageId);
			return;
		}
		if (eagerTimeout) clearTimeout(eagerTimeout);
		if (direction < 0) {
			pageOutDirection = "right";
			pageInDirection = "left";
		} else {
			pageOutDirection = "left";
			pageInDirection = "right";
		}
		const oldSliderHeight = getHeight(sliderRef);
		let oldSliderOuterHeight = getHeight(sliderOuterRef);
		// Removed Jan 23 since pressing Back button was keeping a fixed height in place
		// sliderOuterRef.style.height = `${oldSliderOuterHeight}px`;

		await tick();

		$navigating = true;
		let newIndex =
			pageDisplay.findIndex((x) => x.id === currentPageId) + direction;

		// Check if the new page is visible, if not, find the next visible page
		while (
			newIndex >= 0 &&
			newIndex < pageDisplay.length &&
			!pageDisplay[newIndex].visibleComputed
		) {
			newIndex += direction;
		}

		// If no valid page is found, do not navigate
		if (newIndex >= pageDisplay.length) {
			return;
		}

		if (newIndex < 0) {
			currentPageId = "welcome";
		} else {
			currentPageId = pageDisplay[newIndex].id;
		}

		if (stopNavigationTimeout) {
			clearTimeout(stopNavigationTimeout);
		}

		await tick();

		currentHeight = getHiddenElementHeight(sliderRef);
		oldHeight = oldSliderHeight;

		fireGoogleEvent("form_page_view");

		stopNavigationTimeout = setTimeout(() => {
			message("page", currentPageId);
			const fields_on_page = fieldDisplay.filter(
				(x) => x.page === currentPageId && x.visibleComputed
			);
			if (
				fields_on_page[0] &&
				["OneLineInput", "Comment", "Email", "Date"].includes(
					fields_on_page[0].type
				)
			) {
				const field_cover = document.querySelector(
					`[data-field-id="${fields_on_page[0].id}"] input, [data-field-id="${fields_on_page[0].id}"] textarea`
				);
				if (field_cover) {
					if (["Date", "Time"].includes(fields_on_page[0].type)) {
						if (
							"valueComputed" in fields_on_page[0] &&
							fields_on_page[0].valueComputed === ""
						) {
							(field_cover as HTMLInputElement).focus();
						}
					} else {
						(field_cover as HTMLInputElement).focus();
					}
				}
			}
			$navigating = false;
		}, $timing.duration);
		requestAnimationFrame(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		});
	};

	function onEnter(e: KeyboardEvent) {
		const target = e.target as HTMLElement;
		if (target.classList.contains("back-button")) {
			if (e.key === "Enter") {
				navigate(-1);
				return;
			}
		}
		if ($currentField.action && $currentField.tracking?.type === "Comment") {
			return;
		}
		if (e.key === "Enter") {
			if (!lastSlide) {
				navigate(1);
			}
		}
	}

	function startForm() {
		$visitMeta.start = Date.now();
		$visit.start = true;
		navigate(1);
	}

	const visitStartForm = () => {
		if (!$visit.start && BROWSER && multiPageRef) {
			multiPageRef.removeEventListener("mouseenter", onPageEnter);
			multiPageRef.removeEventListener("mouseleave", onPageLeave);
		}
	};

	const onPageEnter = () => {
		mouseEnterDelay = setTimeout(() => {
			$visitMeta.start = Date.now();
			$visit.start = true;
			visitStartForm();
		}, 1500);
	};

	const onPageLeave = () => {
		if (mouseEnterDelay) {
			clearTimeout(mouseEnterDelay);
		}
	};

	$: if ($mounted) formInit();

	async function formInit() {
		currentHeight = getHiddenElementHeight(sliderRef);
	}

	$: hideSubmitButton =
		currentPageId !== "welcome" &&
		lastSlide &&
		$formMeta.submitButtonVisible === false;

	onMount(async () => {
		if (BROWSER) {
			window.addEventListener("keydown", onEnter);
			multiPageRef.addEventListener("mouseenter", onPageEnter);
			multiPageRef.addEventListener("mouseleave", onPageLeave);
			document.addEventListener("visibilitychange", handleVisibilityChange);
		}
	});

	onDestroy(() => {
		if (BROWSER) {
			document.removeEventListener("visibilitychange", handleVisibilityChange);
			window.removeEventListener("keydown", onEnter);
		}
	});
</script>

<div
	bind:this="{multiPageRef}"
	class="{seamless && iframe ? '' : 'padding-container'} {hidden
		? 'invisible-container'
		: ''} multi-page-container">
	{#if enableHeader}
		<div
			class="header-text"
			in:slideOld="{{
				easing: sineIn,
				delay: $timing.duration * $timing.out,
				duration: slideDuration
			}}"
			out:slideOld="{{
				easing: sineIn,
				delay: $timing.duration * $timing.out,
				duration: $timing.duration ? slideDuration : 0
			}}">
			{#if showBack}
				<button
					class="back-button header-item"
					type="button"
					in:pageIn|global="{{
						distance: 40,
						direction: pageInDirection,
						start: 1 - $timing.in,
						duration: $timing.duration * 1.2,
						easingDistance: bezier(0, 1.15, 0.5, 0.95),
						easingOpacity: sineIn
					}}"
					out:pageOut="{{
						distance: 10,
						direction: pageOutDirection,
						duration: $timing.duration * $timing.out * 0.8,
						easingOpacity: bezier(0.5, 0, 1, 1),
						easingDistance: bezier(0, 1, 1, 1)
					}}"
					disabled="{formLoading}"
					on:click="{() => navigate(-1)}">
					<span class="left-arrow font-initial">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="13"
							height="13"
							fill="currentColor"
							viewBox="0 0 256 256"
							><path
								d="M228,128a12,12,0,0,1-12,12H69l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L69,116H216A12,12,0,0,1,228,128Z"
							></path
							></svg>
					</span>
					<div style="padding-right: 0.5rem">
						<span> {t?.get("back") ?? "Back"} </span>
					</div>
				</button>
			{/if}
			{#if styling.showPageTitles}
				{#key currentPageId}
					<div
						class="page-title header-item"
						in:pageIn|global="{{
							distance: 40,
							direction: pageOutDirection,
							start: 1 - $timing.in,
							duration: $timing.duration * 1.2,
							easingDistance: bezier(0, 1.15, 0.5, 0.95),
							easingOpacity: sineIn
						}}"
						out:fade="{{
							duration: 0
						}}">
						{currentPageLabel}
					</div>
				{/key}
			{/if}
		</div>
	{/if}
	<Slider
		oldHeight="{oldHeight}"
		currentHeight="{currentHeight}"
		easing="{sineIn}"
		bind:elementOuter="{sliderOuterRef}"
		bind:element="{sliderRef}"
		duration="{$timing.duration}">
		<div class="slider-in" style="{$navigating ? 'overflow: hidden' : ''}">
			{#if currentPageId === "welcome"}
				<div
					in:pageIn="{{
						distance: 40,
						direction: pageInDirection,
						start: 1 - $timing.in,
						duration: $timing.duration,
						easingDistance: bezier(0, 1.15, 0.5, 0.95),
						easingOpacity: sineIn
					}}"
					out:pageOut="{{
						direction: pageOutDirection,
						duration: $timing.duration * $timing.out,
						easingOpacity: bezier(0.5, 0, 1, 1),
						easingDistance: bezier(0, 1, 1, 1)
					}}"
					class="page-welcome page-content">
					<div class="richtext" class:richtext-center="{styling.welcomeCenter}">
						{@html $formMeta.welcomePageContent}
					</div>
					<div
						class="form-welcome-button-cover"
						style="align-items: {styling.welcomeCenter
							? 'center'
							: 'flex-start'}">
						<button
							class="button welcome-button"
							type="button"
							disabled="{isLookupLoading}"
							on:click="{startForm}">
							{@html $formMeta.welcomePageButton}
							{#if $mounted || $timing.duration === 0}
								<div
									class="icon-transition"
									transition:slideOld="{{
										delay: $timing.duration,
										duration: $timing.duration * 0.75,
										axis: 'x'
									}}">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="0.95rem"
										height="0.95rem"
										fill="currentColor"
										viewBox="0 0 256 256"
										><path
											d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z"
										></path
										></svg>
								</div>
							{/if}
						</button>
						{#if plan.whitelabel === false && iframe === true}
							<a
								href="{powered_by_link}"
								target="_blank"
								class="powered-by-link-text">
								{@html t
									.get("powered_by")
									.replace(
										"{0}",
										'<span style="font-weight: 600">formcrafts</span>'
									)}
							</a>
						{/if}
					</div>
				</div>
			{:else}
				<div
					class="other-pages-cover"
					in:pageIn="{{
						distance: 40,
						direction: pageInDirection,
						start: 1 - $timing.in,
						duration: $timing.duration,
						easingDistance: bezier(0, 1.15, 0.5, 0.95),
						easingOpacity: sineIn
					}}"
					out:pageOut="{{
						direction: pageOutDirection,
						duration: $timing.duration * $timing.out,
						easingOpacity: bezier(0.5, 0, 1, 1),
						easingDistance: bezier(0, 1, 1, 1)
					}}">
					<div class="slider-pages">
						{#each pageDisplay as page, page_index (page.id)}
							{@const currentFields = fieldDisplay.filter(
								(x) => x.page === currentPageId
							)}
							{#if page.id === currentPageId}
								<div
									in:pageIn="{{
										distance: 40,
										direction: pageInDirection,
										start: 1 - $timing.in,
										duration: $timing.duration,
										easingDistance: bezier(0, 1.15, 0.5, 0.95),
										easingOpacity: sineIn
									}}"
									out:pageOut="{{
										direction: pageOutDirection,
										duration: $timing.duration * $timing.out,
										easingOpacity: bezier(0.5, 0, 1, 1),
										easingDistance: bezier(0, 1, 1, 1)
									}}"
									class="fields-container">
									{#each currentFields as field (field.id)}
										{#if field.visibleComputed && (test === true || field.type !== "Hidden")}
											<DisplayField field="{field}" on:updateOther />
										{/if}
									{/each}
								</div>
							{/if}
						{/each}
					</div>
				</div>
			{/if}
		</div>
		{#if formError}
			<div
				transition:slide="{{ duration: $timing.duration * 0.5 }}"
				class="error-message">
				{formError}
			</div>
		{/if}
	</Slider>
	{#if currentPageId !== "welcome"}
		<div
			class="form-footer-cover"
			class:is-hidden="{hideSubmitButton}"
			out:slideOld="{{
				easing: sineIn,
				duration: slideDuration,
				delay: $timing.out * $timing.duration
			}}"
			in:slideOld="{{
				easing: sineIn,
				duration: slideDuration,
				delay: $timing.out * $timing.duration
			}}">
			<div
				class="form-footer-cover-inner"
				in:pageIn="{{
					distance: 40,
					direction: pageInDirection,
					start: 1 - $timing.in,
					duration: $timing.duration,
					easingDistance: bezier(0, 1.15, 0.5, 0.95),
					easingOpacity: sineIn
				}}"
				out:pageOut="{{
					distance: 10,
					direction: pageOutDirection,
					duration: $timing.duration * $timing.out,
					easingOpacity: bezier(0.5, 0, 1, 1),
					easingDistance: bezier(0, 1, 1, 1),
					absolute: false
				}}">
				<Footer
					formLoading="{formLoading}"
					powered_by="{plan.whitelabel === false && iframe === true
						? powered_by_link
						: null}"
					currentPageId="{currentPageId}"
					pages="{pageDisplay}"
					eagerTimeout="{eagerTimeout}"
					navigate="{navigate}"
					lastSlide="{lastSlide}" />
			</div>
		</div>
	{/if}
</div>
